// Override Settings
var bcSfSearchSettings = {
    search: {
      //suggestionMode: 'test',
      //suggestionPosition: 'left',
      //enableFuzzy: true,
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

// Build number of Search result
BCSfFilter.prototype.buildSearchResultNumber = function(data) {
    var content = '';
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm != null) {
      	content = bcSfFilterConfig.label.search_result_number_other;
      	if (data.total_product == 1) {
          	content = bcSfFilterConfig.label.search_result_number_one;
      	}
        content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ search_terms }}/g, searchTerm);
    }
    jQ('.' + this.class.searchResultNumber).html(content);
};


// Build Products
BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var result = '';
    // Buid Header
    result += this.buildSuggestionHeader(itemInfo['label'], 'product');
    // Build Did you mean
    var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
    if (dym != '') {
        result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
    }
    // Build content
    if (Object.keys(itemData).length > 0) {
        var count = 0;
        for (var k in itemData) {
            if (count < itemInfo['number']) {
                var product = itemData[k];
                // Get product attributes
                var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, itemData);
                productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
                var productUrl = this.buildProductItemUrl(product, false);
                var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], '200x') : bcSfFilterConfig.general.no_image_url;
                var productSku = product.skus !== null && product.skus.length > 1 ? product['skus'][1] : product['skus'][0];
                // Get custom class / attribute
                var searchSuggestionClass = this.class.searchSuggestion;
                var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
                result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
                result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
                // Build Left column
                if (this.getSettingValue('search.showSuggestionProductImage')) {
                    result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
                }
                // Build Right column
                result += '<div class="' + searchSuggestionClass + '-right">';
                result += '<div class="' + searchSuggestionClass + '-product-title">' + productTitle + '</div>';
                if (this.getSettingValue('search.showSuggestionProductSku')) {
                    result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
                }
                if (this.getSettingValue('search.showSuggestionProductVendor')) {
                    result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
                }
                result += this.buildSuggestionProductPrice(product);
                result += '</div>'; // End Right column
                result += '</a>'; // End a
                result += '</li>'; // End li
                count++;
            } else break;
        }
    }
    return result;
};

BCSfFilter.prototype.buildSuggestionPage = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var result = '';
  	var haveBlogs = false;
    if (Object.keys(itemData).length > 0) {
        // Build content
        var result = this.buildSuggestionHeader(itemInfo['label'], 'page');
        for (var k in itemData) {
            if (k < itemInfo['number'] && itemData[k]['url'].indexOf('blogs') < 0) {
                var searchResult = this.highlightSuggestionResult(itemData[k]['title'], searchTerm);
                result += '<li class="' + this.class.searchSuggestionItem + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]['title']) + '">';
                result += '<a href="' + itemData[k]['url'] + '">' + searchResult + '</a>';
                result += '</li>';
            } else {
              	haveBlogs = true;
            }
        }
      
      	if (haveBlogs) {
          	result += '<li class="bc-sf-search-suggestion-header-page bc-sf-search-suggestion-header ui-menu-item" aria-label="Blogs">Inspiration</li>';
          	for (var k in itemData) {
                if (itemData[k]['url'].indexOf('blogs') > -1) {
                    var searchResult = this.highlightSuggestionResult(itemData[k]['title'], searchTerm);
                    result += '<li class="' + this.class.searchSuggestionItem + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]['title']) + '">';
                    result += '<a href="' + itemData[k]['url'] + '">' + searchResult + '</a>';
                    result += '</li>';
                }
            }
        }
      	
    }
  
    return result;
}

BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var result = '';
    // Buid Header
    result += this.buildSuggestionHeader(itemInfo['label'], 'product');
    // Build Did you mean
    var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
    if (dym != '') {
        result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
    }
    // Build content
    if (Object.keys(itemData).length > 0) {
        var count = 0;
        for (var k = 0; k < itemData.length; k++) {
            if (count < itemInfo['number']) {
                var product = itemData[k];
                // Get product attributes
                var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, itemData);
                productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
                var productUrl = this.buildProductItemUrl(product, false);
                var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], '200x') : bcSfFilterConfig.general.no_image_url;
                var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][product.skus.length - 1] : '';
                // Get custom class / attribute
                var searchSuggestionClass = this.class.searchSuggestion;
                var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
                result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
                result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
                // Build Left column
                if (this.getSettingValue('search.showSuggestionProductImage')) {
                    result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
                }
                // Build Right column
                result += '<div class="' + searchSuggestionClass + '-right">';
                result += '<div class="' + searchSuggestionClass + '-product-title">' + productTitle + '</div>';
                if (this.getSettingValue('search.showSuggestionProductSku')) {
                    result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
                }
                if (this.getSettingValue('search.showSuggestionProductVendor')) {
                    result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
                }
                result += this.buildSuggestionProductPrice(product);
                result += '</div>'; // End Right column
                result += '</a>'; // End a
                result += '</li>'; // End li
                count++;
            } else break;
        }
    }
    return result;
};

/* Start Search Redirect */
function submitSearchFormMobile(t,e){e.preventDefault();var o=bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm);o?window.location.href=o:jQ(t).closest("form").submit()}function beforeSubmitSearchForm(t,e){var o=jQ(t).val(),i=bcsffilter.getSearchRedirectUrl(o);i&&(e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault(),window.location.href=i)}BCSfFilter.prototype.setSuggestionPosition=function(t){var e=this;if("function"==typeof getSuggestionPosition&&"function"==typeof this.checkIsFullWidthSuggestionMobile){var o=getSuggestionPosition(t),i=this.checkIsFullWidthSuggestionMobile(t)?"top":"top+12";"function"!=typeof e.isSuggestionStyle2||e.isSuggestionStyle2(),"left"==o?jQ(t).autocomplete("option","position",{my:"left "+i,at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right "+i,at:"right bottom",collision:"none"})}else"left"==this.getSettingValue("search.suggestionPosition")?jQ(t).autocomplete("option","position",{my:"left top+12",at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right top+12",at:"right bottom",collision:"none"});if(jQ(t).length>0&&jQ(t).on("keydown",function(o){13==o.keyCode&&e.enterSearchBoxEvent(t,o)}),jQ(t).closest("form").length>0){var n=jQ(t).closest("form").find('[type="submit"]');n&&n.length>0&&n.each(function(e,o){o.setAttribute("onclick","beforeSubmitSearchForm('"+t+"', event)")})}},BCSfFilter.prototype.enterSearchBoxEvent=function(t,e){var o=jQ(t).val(),i=this.getSearchRedirectUrl(o);i&&(e.preventDefault(),window.location.href=i)},BCSfFilter.prototype.getSearchRedirectUrl=function(t){if(this.suggestionCache&&this.suggestionCache.hasOwnProperty(t))for(var e=this.suggestionCache[t],o=0;o<e.length;o++)if("redirect"==e[o].key&&e[o].values){var i=e[o].values;return i=(i=i.replace("https://"+bcSfFilterMainConfig.shop.domain,"")).replace("http://"+bcSfFilterMainConfig.shop.domain,"")}return""};
/* End Search Redirect */
